import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useState } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { Menu } from 'react-native-paper';
import { Colors } from '../../themes/colors';
import {
  onSelectTierProps,
  SubscriptionTier,
  SubscriptionTierSelector,
} from './subscriptionTierSelector';
import { textStyles } from '../../styles';

type SubscriptionTierMenuProps = {
  workspaceId: string;
  currentTierId: string | undefined;
  currentTierName: string | undefined;
  onSelect: (props: onSelectTierProps) => Promise<void>;
  tierList: SubscriptionTier[];
};

export const SubscriptionTierMenu = ({
  workspaceId,
  currentTierId,
  currentTierName,
  onSelect,
  tierList,
}: SubscriptionTierMenuProps) => {
  const [visible, setVisible] = useState(false);

  const openMenu = () => setVisible(true);
  const closeMenu = () => setVisible(false);

  return (
    <Menu
      visible={visible}
      onDismiss={closeMenu}
      contentStyle={styles.menuContent}
      anchor={
        <Pressable onPress={openMenu}>
          <View style={styles.anchor}>
            <Text style={textStyles.default}>{currentTierName || ''}</Text>
            <MaterialCommunityIcons
              name={visible ? 'chevron-up' : 'chevron-down'}
              size={24}
              color={Colors.role.textPrimary}
            />
          </View>
        </Pressable>
      }
    >
      <SubscriptionTierSelector
        workspaceId={workspaceId}
        currentTierId={currentTierId}
        onSelect={onSelect}
        tierList={tierList}
        closeMenu={closeMenu}
      />
    </Menu>
  );
};

const styles = StyleSheet.create({
  menuContent: {
    backgroundColor: Colors.role.surface,
    flexDirection: 'column',
    flex: 1,
    top: 30,
  },
  anchor: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});
